import { useCallback, useEffect, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
// import { EditorState, Extension } from '@codemirror/state';
import { Decoration, ViewPlugin } from '@codemirror/view';
import './index.less';
// import { isValidPrivateKeyBase58, isValidPrivateKeyBytes } from '@/utils/methods';
import { useTranslation } from 'react-i18next';
import { isValidPrivateKey } from '@/utils/check';
// import { scrollbarThemeOption } from '@/config/codeMirror';

function highlightDuplicatesPlugin(setShowDuplicateAlert: any, setShowInvalidAlert: any, onError: any) {
  return ViewPlugin.fromClass(class {
    decorations;

    constructor(view: any) {
      this.decorations = this.findDuplicates(view.state);
    }

    update(update: any) {
      if (update.docChanged) {
        this.decorations = this.findDuplicates(update.state);
      }
    }

    findDuplicates(state: any) {
      const decorations: any = [];
      const text = state.doc.toString();
      const lines = text.split('\n');
      const seen = new Map();
      let foundDuplicate = false;
      let foundInvalid = false;

      lines.forEach((line: any, index: any) => {
        const addressPart = line.trim();

        if (seen.has(addressPart) && addressPart !== '') {
          foundDuplicate = true;
          const deco = Decoration.line({ attributes: { class: 'red-background' } });
          decorations.push(deco.range(state.doc.line(index + 1).from));
        } else if (addressPart !== '' && !isValidPrivateKey(addressPart)) {
          foundInvalid = true;
          const deco = Decoration.line({ attributes: { class: 'invalid-background' } });
          decorations.push(deco.range(state.doc.line(index + 1).from));
        } else if (addressPart !== '') {
          seen.set(addressPart, true);
        }
      });

      setShowDuplicateAlert(foundDuplicate);
      setShowInvalidAlert(foundInvalid);
      onError && onError(foundInvalid || foundDuplicate);
      return Decoration.set(decorations, true);
    }
  }, {
    decorations: v => v.decorations
  });
}

export default function CodeMirrorInput(props: any) {
  const { placeholder, onInputCode, code, onError } = props;
  const [value, setValue] = useState(code || "");
  const [extensions, setExtensions] = useState<any>([]);
  const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);
  const [showInvalidAlert, setShowInvalidAlert] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setExtensions([
      javascript({ jsx: true }),
      highlightDuplicatesPlugin(setShowDuplicateAlert,
        setShowInvalidAlert,
        onError)
    ]);
  }, []);

  const onChange = useCallback((val: any,) => {
    // console.log('val:', val);
    setValue(val);
    onInputCode && onInputCode(val);
  }, []);

  function renderTipsInvalid() {
    return <p className='error'>{t('BatchCollection.invalidPrivateKey')}</p>;
  }

  return (<div className='key-code-mirr-box'>
    <div className='code-mirr'>
      <CodeMirror
        value={value}
        width='100%'
        maxWidth='100%'
        minHeight="272px"
        maxHeight='282px'
        placeholder={placeholder}
        extensions={extensions}
        onChange={onChange} />
    </div>
    {
      showDuplicateAlert && <p className='error'>{t("BatchCollection.duplicatePrivateKeyInList")}</p>
    }
    {
      showInvalidAlert && renderTipsInvalid()
    }
  </div>);
}
